var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCreditCardBadge(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11 5H1M11 5.5V4.1C11 3.53995 11 3.25992 10.891 3.04601C10.7951 2.85785 10.6422 2.70487 10.454 2.60899C10.2401 2.5 9.96005 2.5 9.4 2.5H2.6C2.03995 2.5 1.75992 2.5 1.54601 2.60899C1.35785 2.70487 1.20487 2.85785 1.10899 3.04601C1 3.25992 1 3.53995 1 4.1V7.9C1 8.46005 1 8.74008 1.10899 8.95399C1.20487 9.14215 1.35785 9.29513 1.54601 9.39101C1.75992 9.5 2.03995 9.5 2.6 9.5H5.75M9 10.5C9 10.5 10.5 9.78505 10.5 8.71261V7.46144L9.4062 7.0706C9.1434 6.97647 8.856 6.97647 8.5932 7.0706L7.5 7.46144V8.71261C7.5 9.78505 9 10.5 9 10.5Z",
    stroke: "#0BA5EC",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCreditCardBadge);
export default __webpack_public_path__ + "static/media/credit-card-badge.7a079e86ccff8e878df2c11f57292688.svg";
export { ForwardRef as ReactComponent };